import { updateFramesRelativeDurations } from 'state/actions';
import { getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

export class ChangeLayerFramesRelativeDurationsCommand extends Command {
  layerId: string;
  value: number[];
  prevValue: number[];
  constructor(layerId: string, value: number[]) {
    super();
    this.layerId = layerId;
    this.value = value;
    this.canMerge = true;
  }

  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const layer = getLayerById(getState().flyer, this.layerId);
      if (layer) {
        if (firstTime) {
          this.prevValue = layer.frames.map(f => f.relativeDuration);
        }
        dispatch(updateFramesRelativeDurations(layer, this.value));
      }
    };
  }

  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const layer = getLayerById(getState().flyer, this.layerId);
      if (layer) {
        dispatch(updateFramesRelativeDurations(layer, this.prevValue));
      }
    };
  }

  merge(nextCommand: Command): void {
    if (nextCommand instanceof ChangeLayerFramesRelativeDurationsCommand) {
      if (this.value.length === nextCommand.value.length) {
        this.value = nextCommand.value;
      } else {
        throw new Error(
          `Cannot merge because it's has different amount of frames`
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/ChangeLayerFramesRelativeDurationsCommand.ts